<div class="forecast-wrapper">
    <div *ngIf="!windData; else elseBlock">{{noWindData}}.</div>
    <ng-template #elseBlock>
        <div>
            <img *ngIf="windDirIcon" 
                class=".icon"
                [src]="windDirIcon" 
                [alt]="windDir ?? 'Wind direction'">
        </div>
        <div class="desc-wrapper">
            <span class="desc-text">{{getWindDirection()}}</span>
        </div>  
    </ng-template>
  
</div>